
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hailuo-ai-video-generator",
      function () {
        return require("private-next-pages/hailuo-ai-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hailuo-ai-video-generator"])
      });
    }
  